/* eslint-disable */
Parsley.addValidator('presenceOneInGroup', {
  messages: {
    en: I18n.t('js.email_or_phone_must_be_present'),
  },
  requirementType: 'string',
  validate(_value, requirement, _instance) {
    const inputsToValidate = document.querySelectorAll(`[data-parsley-presence-one-in-group='${requirement}']`);

    const result = [].slice.call(inputsToValidate).map((currentInput, _index, _array) => {
      const val = currentInput.value;
      return (!val || val.length === 0);
    });

    return result.includes(false);
  },
});

Parsley.addValidator('filetypes', {
    requirementType: 'string',
    validateString: function (value, requirement, parsleyInstance) {

      let file = parsleyInstance.$element[0].files;

      if (file.length == 0) {
        return true;
      }

      let allowedMimeTypes = requirement.replace(/\s/g, "").split(',');
      return allowedMimeTypes.indexOf(file[0].type) !== -1;

    },
    messages: {
      en: I18n.t('js.incorrect_file_type')
    }
});

// Size in mega bites
Parsley.addValidator('fileSize', {
  requirementType: 'string',
  validateString: function (value, requirement, parsleyInstance) {

    let file = parsleyInstance.$element[0].files[0],
        fileSize = file.size / 1000000;

    return fileSize < requirement;

  },
  messages: {
    en: I18n.t('js.file_size_error', { size: '%s' })
  }
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/parsley_custom_validators.js